var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"body-style":{padding: '24px 32px'},"bordered":false}},[_c('icon-selector',{on:{"change":_vm.handleIconChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }